import { render, staticRenderFns } from "./category-bisac-edit.vue?vue&type=template&id=50f47d66&"
import script from "./category-bisac-edit.vue?vue&type=script&lang=js&"
export * from "./category-bisac-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports